// extracted by mini-css-extract-plugin
export default {"page":"profile_page__8uF8s","form":"profile_form__Ulu7A","tab":"profile_tab__fdaPG","paper":"profile_paper__sPOfV"};